import { Typography } from '@mui/material'
import { Flex, theme } from '@clara/ui'
import { WithChildren } from '@clara/react-utils'

export interface RowItemProps extends WithChildren {
  title: string
  value?: string
  column?: boolean
}

export const RowItem = ({
  title,
  value = '',
  column,
  children,
}: RowItemProps) => {
  const { v3: brand } = theme.palette

  return (
    <Flex
      flexDirection={column ? 'column' : 'row'}
      justifyContent={'space-between'}
      alignItems={column ? 'flex-start' : 'center'}
      pl={1}
      sx={{ borderBottom: `1px solid ${brand.border.disabled}` }}
      py={1.5}
    >
      <Typography variant="body1" sx={{ color: brand.content.low_emphasis }}>
        {title}
      </Typography>

      {children || (
        <Typography
          variant="body1"
          sx={{
            color: brand.content.high_emphasis,
            textAlign: 'right',
          }}
        >
          {value}
        </Typography>
      )}
    </Flex>
  )
}
